import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "markdown-link-share-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round" },
        React.createElement("path", { d: "M9.207 7.793a2.5 2.5 0 0 1 0 3.535l-1.414 1.415a2.5 2.5 0 0 1-3.536-3.536l1.061-1.06h0" }),
        React.createElement("path", { d: "M7.793 9.207a2.5 2.5 0 0 1 0-3.535l1.414-1.415a2.5 2.5 0 0 1 3.536 3.536l-1.061 1.06h0" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
